import styled, { css } from "styled-components";

export const LoaderOverlayMain = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: ${({ theme }) => theme.coreBackground};
  display: block;

  ${(props) => props.fixed && css`
    position: fixed;
  `};
`;

export const LoaderOverlayMainPadding = styled.div`
  width: 100%;
  height: 100%;
`;

export const LoaderOverlayMainInner = styled.div`
  position: absolute;
  margin: auto;
  top: 0;
  bottom:0;
  left: 0;
  right: 0;
  height: 120px;
  width: 120px;
  color: ${({ theme }) => theme.headerTextColor};
  background: ${({ theme }) => theme.coreBackground};
  box-shadow: 0 1px 8px ${({ theme }) => theme.backgroundColor};
  padding: 0;
  border-radius: 50%;
  align-items: center;
`;

export const LoaderText = styled.div`
  width: 100%;
  text-align:center;
  font-size: 12px;
  font-weight: 300;
  color: ${({ theme }) => theme.headerTextColor};
  padding: 10px 0;
`;

export const LoaderButton = styled.div`
  width: 100%;
  text-align: center;
  padding: 10px;
`;